<template>
    <div class="relative max-h-[70dvh] overflow-y-auto pb-4">
        <ModelSearchInput
            v-model="usersToInvite"
            :multiple="true"
            id="user_id"
            ref="userInput"
            resultsMaxHeight="max-h-[300px]"
            :smallResults="true"
            :popoverWidthMultiplier="0.5"
            alignment="left"
            :teleportTarget="modalTeleportTarget"
            :label="
                $getBaseModelTranslation({
                    modelName: 'user',
                    capitalize: true,
                })
            "
            :description="
                $lang.get('Search for :users to invite', {
                    users: $getBaseModelTranslation({
                        modelName: 'user',
                        wordClass: 'plural',
                    }),
                })
            "
            :placeholder="
                $lang.get('Search for :singular_model', {
                    singular_model: $getBaseModelTranslation({
                        modelName: 'user',
                    }),
                })
            "
            :modelClasses="['user']"
            :disabledModels="disabledUsers"
            :selectedTitle="
                $lang.get(':users to invite', {
                    users: $getBaseModelTranslation({
                        modelName: 'user',
                        wordClass: 'plural',
                        capitalize: true,
                    }),
                })
            "
        />
        <div class="flex justify-center gap-x-2 mt-4">
            <SecondaryButton
                @click="$emit('cancel')"
                v-text="$lang.get('Cancel')"
                :filled="true"
            />
            <PrimaryButton
                @click="sendInvites"
                :disabled="usersToInvite.length == 0"
                v-text="sendInviteText ?? $lang.get('Send invites')"
            />
        </div>
    </div>
</template>

<script>
import PrimaryButton from '@/Components/Elements/PrimaryButton.vue'
import SecondaryButton from '@/Components/Elements/SecondaryButton.vue'
import ModelSearchInput from '@/Components/FormElements/ModelSearchInput/ModelSearchInput.vue'

export default {
    name: 'AffiliationInvitationForm',
    components: {
        ModelSearchInput,
        SecondaryButton,
        PrimaryButton,
    },
    emits: ['cancel', 'sendInvites'],

    props: {
        modalTeleportTarget: {
            type: String,
            required: true,
        },
        confirmedItems: {
            type: Array,
            default: [],
        },
        sentRequests: {
            type: Array,
            default: [],
        },
        recievedRequests: {
            type: Array,
            default: [],
        },
        alreadyConfirmedMsg: {
            type: String,
            required: true,
        },
        alreadySentMsg: {
            type: String,
            required: true,
        },
        alreadyRequestedMsg: {
            type: String,
            required: true,
        },
        sendInviteText: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            usersToInvite: [],
        }
    },

    mounted() {
        this.$refs.userInput.focusMethod()
    },

    methods: {
        sendInvites() {
            this.$emit('sendInvites', this.usersToInvite)
            this.usersToInvite = []
        },
    },

    computed: {
        /**
         * Returns an array of user ids that are already connected somehow and provides a message that
         * describes the reason why they are disabled.
         */
        disabledUsers() {
            // let items = []
            return [
                // Added items
                ...this.confirmedItems.map((item) => ({
                    modelId: item.id,
                    modelClass: 'user',
                    message: this.alreadyConfirmedMsg,
                })),
                // invited items
                ...this.sentRequests.map((item) => ({
                    modelId: item.target_id,
                    modelClass: 'user',
                    message: this.alreadySentMsg,
                })),
                // // requested items
                ...this.recievedRequests.map((item) => ({
                    modelId: item.initiator_id,
                    modelClass: 'user',
                    message: this.alreadyRequestedMsg,
                })),
            ]
        },
    },
}
</script>
